import { createBrowserRouter } from "react-router-dom";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import MultipleQuestionModal from "./Modal/MultipleQuestionModal";
import SubjectiveQuestionModal from "./Modal/SubjectiveQuestionModal";
import { useRecoilValue } from "recoil";
import { gameProposalIdState } from "src/recoil/atoms/gameProposalState";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { LabsQuestionComposeAPI, LabsQuestionOverviewAPI, QuestionsBySourceAPI, GameProposalDetailsAPI } from "../../TestManagementApi";
import HamburgerIcon from 'src/components/common/icons/HamburgurIcon';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import LimitModal from './Modal/LimitModal';
import GenreModal from './Modal/GenreModal';
import CustomNavLink from '../components/CustomNavLink';
import { GameProposalStepAvailabilityAPI } from "../AddTestApi";
import { GameProposalStepAvailabilityResponse } from "../../types/Response";
import { SuccessModal } from "../components/SuccessModal";
import OnJudgingPhase3 from "./OnJudgingPhase3";
// import ApprovedPhase3 from "../../TestList/ApprovedTestEdit";
import {CheckPageMoveModal} from '../components/CheckPageMoveModal';

const Main = styled.main`
  background-color: #f8f9fa;
  width: 100%;
  min-width: 1280px;
  max-width: 1920px;
  height: 100vh;
  
  padding-left: 195px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TopWrapper = styled.div`
  padding-left: 80px;
  border-bottom: 1px solid #ededed;
  min-height: 157px;
  display: flex;
  flex-direction: column;
  gap: 34px;
  padding-top: 30px;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 2;
`;

const TopContainer = styled.div`
  // width: 1280px;
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TopTitle = styled.span`
  color: #2282e9;
  font-size: 20px;
  font-weight: 700;
`;

const BtnContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const TopBtn = styled.button`
  width: 160px;
  height: 55px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #ededed;
  color: #c0c0c0;
  font-weight: 600;
  cursor: pointer;
`;

const PreviewBtn = styled(TopBtn)`
  color: white;
  background-color: #2282e9;
`;

const SaveBtn = styled(TopBtn)`
  color: #2282e9;
  border: 1px solid #2282e9;
`;

const NavCotainer = styled.div`
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 1280px;
  height: 37px;
`;

const Nav = styled.div`
  width: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AccentNav = styled(Nav)`
  border-bottom: 2px solid #2282e9;
  color: #2282e9;
`;

const ContentWrapper = styled.div`
  padding-top: 70px;
  padding-left: 125px;
  padding-bottom: 309px;
  overflow-y: auto;
  height: calc(100vh - 157px);
`;

const Title = styled.span`
  font-weight: 600;
  font-size: 18px;
`;

const Required = styled.span`
  color: #2282e9;
  font-weight: 600;
  font-size: 18px;
`;

const Comment = styled.span`
  display: block;
  line-height: 26px;
  color: #9f9f9f;
  margin-top: 8px;
  margin-bottom: 20px;
`;

const QuestionWrapper = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 70px;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 358px;
  height: 209px;
  border-radius: 10px;
  border: 1.5px solid #e3e3e3;
  background-color: white;
`;

const QuestionTitle = styled.span`
  display: block;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 29px;
`;
const QuestionContent = styled.span`
  display: block;
  font-weight: 500;
  font-size: 14px;
  color: #8e8e8e;
  margin-bottom: 34px;
`;

const QuestionBtn = styled.button<{isActive: boolean}>`
  border-radius: 999px;
  width: 223px;
  height: 45px;
  border: none;
  color: ${props => props.isActive ? '#FFFFFF' : '#2282e9'};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;  
  background-color: ${props => props.isActive ? '#2282e9' : '#ebf5ff'};
`;

const QuestionBox = styled.div`
  // width: 1280px;
  width: 90%;
  height: 300px;
  border-radius: 10px;
  background-color: white;
  border: 1px solid #EBF5FF;
  margin-bottom: 10px;
  overflow-y: auto;
  padding: 12px;
`;

const AddQuestionBtn = styled.button`
  display: block;
  // width: 1280px;
  width: 90%;
  height: 49px;
  border-radius: 5px;
  border: 1px solid #2282e9;
  background-color: white;
  margin-bottom: 70px;
  font-weight: 600;
  color: #2282e9;
  cursor: pointer;
`;

const DraggableList = styled.div`
  width: 100%;
  position: relative;
`;

const DraggableItem = styled.div<{ isDragging?: boolean }>`
  margin-bottom: 12px;
  position: relative;
  height: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }

  ${props => props.isDragging && `
    position: absolute;
    width: calc(100% - 24px); // 좌우 margin 12px 고려
    z-index: 999;
  `}
`;

const QuestionItemContainer = styled.div<{ isCustom?: boolean; isDragging?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: ${props => props.isCustom ? '#2282E9' : '#EBF5FF'};
  border-radius: 4px;
  user-select: none;
  touch-action: none;
  height: 40px;
  box-sizing: border-box;
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  margin-right: 36px;
  touch-action: none;
`;

const DeleteButtonContainer = styled.div`
  position: absolute;
  left: 50px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background-color: #f8f9fa;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const MinusIcon = styled.div`
  width: 14px;
  height: 2px;
  background-color: #9f9f9f;
  border-radius: 1px;
`;

const QuestionText = styled.div<{ hasDeleteButton?: boolean }>`
  flex: 1;
  font-size: 14px;
  color: ${props => props.hasDeleteButton ? 'white' : '#333'};
  margin-left: 50px};
`;

const ActionButton = styled.button<{ hasRejection?: boolean }>`
  width: 120px;
  padding: 4px 8px;
  height: 35px;
  border: 1px solid ${props => props.hasRejection ? '#000000' : '#2282e9'};
  margin: -12px 0;
  border-radius: 4px;
  background: ${props => props.hasRejection ? '#000000' : 'white'};
  color: ${props => props.hasRejection ? 'white' : '#2282e9'};
  font-size: 12px;
  cursor: pointer;
  
  &:hover {
    background: ${props => props.hasRejection ? '#333333' : '#ebf5ff'};
  }
`;

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;  // flex로 변경
  align-items: center;   // 중앙 정렬 추가
  width: 165px;
  height: 100%;         // 100%로 변경하여 부모 높이에 맞춤
`;

const Tooltip = styled.div<{ disabled?: boolean }>`
  visibility: hidden;
  position: absolute;
  bottom: calc(100% + 8px);  // 위치 조정
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  
  ${TooltipContainer}:hover & {
    visibility: ${props => !props.disabled ? 'hidden' : 'visible'};
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
`;

interface Question {
  questionId: number;
  content: string;
  category: string;
  custom?: boolean;
  rejectionReason: string;
  choices?: Array<{id: number; content: string}>;
  answerLength?: number;
  minAnswerLength?: number;
  count?: number;
  allowedChoices?: number;
}

export default function AddTestPhase3() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { gameProposalId } = useParams();
  console.log(`phase3 - gameProposalId: `, gameProposalId);

  const { data: QuestionOverviewData } = useQuery({
    queryKey: ["companyInfoOverview", gameProposalId],
    queryFn: async () => {
      const response = await LabsQuestionOverviewAPI(Number(gameProposalId));
      return response.data;
    },
    enabled: !!gameProposalId,
    staleTime: 0,
    // cacheTime: 0
  });

  useEffect(() => {
    console.log(`QuestionOverviewData: `, QuestionOverviewData);
  }, [QuestionOverviewData]);

  

  const [multipleQuestionModal, setMultipleQuestionModal] = useState(false);
  const [subjectiveQuestionModal, setSubjectiveQuestionModal] = useState(false);

  const [selectedRecommendQuestions, setSelectedRecommendQuestions] = useState<Question[]>([]);
  const [selectedSubjectiveQuestions, setSelectedSubjectiveQuestions] = useState<Question[]>([]);

  useEffect(() => {
    if (QuestionOverviewData?.questions && !initialData) {
      // 초기 상태 설정
      const initialState = {
        questionSource: QuestionOverviewData.selectedQuestionSource,
        genre: QuestionOverviewData.genres.find((g: { genre: string; selected: boolean }) => g.selected)?.genre || null,
        multipleQuestions: QuestionOverviewData.questions.multipleChoiceQuestions,
        subjectiveQuestions: QuestionOverviewData.questions.subjectiveQuestions
      };

      // 상태 업데이트
      setSelectedRecommendQuestions(initialState.multipleQuestions);
      setSelectedSubjectiveQuestions(initialState.subjectiveQuestions);
      setSelectedGenre(initialState.genre);
      
      if (initialState.questionSource === 'RECOMMENDED') {
        setIsRecommendQuestionsVisible(true);
        setIsSubjectiveQuestionsVisible(true);
      } else if (initialState.questionSource === 'GENRE_BASED') {
        setIsGenreBasedQuestionsVisible(true);
      }

      // 초기 데이터 저장
      setInitialData(JSON.stringify(initialState));
      setIsDataChanged(false);
    }
  }, [QuestionOverviewData]);

  const [isRecommendQuestionsVisible, setIsRecommendQuestionsVisible] = useState(false);
  const [isSubjectiveQuestionsVisible, setIsSubjectiveQuestionsVisible] = useState(false);
  const [isGenreBasedQuestionsVisible, setIsGenreBasedQuestionsVisible] = useState(false);
  
  const [editingMultipleChoiceQuestion, setEditingMultipleChoiceQuestion] = useState<any>(null);
  const [editingSubjectiveQuestion, setEditingSubjectiveQuestion] = useState<any>(null);

  const [showLimitModal, setShowLimitModal] = useState(false);
  const [limitModalType, setLimitModalType] = useState<'multiple' | 'subjective'>('multiple');

  const [showGenreModal, setShowGenreModal] = useState(false);

  const [selectedGenre, setSelectedGenre] = useState<string | null>(null);

  const [showMoveModal, setShowMoveModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);

  // 초기 데이터를 저장할 상태 추가
  const [initialData, setInitialData] = useState<any>(null);
  const [isDataChanged, setIsDataChanged] = useState(false);

  // 데이터 변경 감지 로직 수정
  useEffect(() => {
    if (!initialData) return;

    const currentState = {
      questionSource: selectedGenre ? 'GENRE_BASED' : (selectedRecommendQuestions.length > 0 ? 'RECOMMENDED' : "NONE"),
      genre: selectedGenre ? selectedGenre : "NONE",
      multipleQuestions: selectedRecommendQuestions,
      subjectiveQuestions: selectedSubjectiveQuestions
    };

    const initialState = JSON.parse(initialData);

    // 깊은 비교를 위한 함수
    const deepEqual = (obj1: any, obj2: any): boolean => {
      if ((obj1 === null || obj1 === "NONE") && (obj2 === null || obj2 === "NONE")) return true;
      if (Array.isArray(obj1) && Array.isArray(obj2)) {
        if (obj1.length !== obj2.length) return false;
        // 배열의 경우 questionId로 정렬 후 비교
        const sorted1 = [...obj1].sort((a, b) => a.questionId - b.questionId);
        const sorted2 = [...obj2].sort((a, b) => a.questionId - b.questionId);
        return JSON.stringify(sorted1) === JSON.stringify(sorted2);
      }
      return obj1 === obj2;
    };

    const hasChanges = 
      !deepEqual(initialState.questionSource, currentState.questionSource) ||
      !deepEqual(initialState.genre, currentState.genre) ||
      !deepEqual(initialState.multipleQuestions, currentState.multipleQuestions) ||
      !deepEqual(initialState.subjectiveQuestions, currentState.subjectiveQuestions);

    console.log('Data comparison:', {
      initial: initialState,
      current: currentState,
      hasChanges
    });

    setIsDataChanged(hasChanges);
  }, [selectedGenre, selectedRecommendQuestions, selectedSubjectiveQuestions]);

  const closeMultipleQuestionModal = () => {
    setMultipleQuestionModal(false);
  };

  const openMultipleQuestionModal = () => {
    const customQuestions = selectedRecommendQuestions.filter(q => q.custom);
    const multipleChoiceLimit = QuestionOverviewData?.customQuestionFreeLimit?.multipleChoiceLimit || 0;

    if (customQuestions.length >= multipleChoiceLimit) {
      setLimitModalType('multiple');
      setShowLimitModal(true);
      return;
    }
    setEditingMultipleChoiceQuestion(null); 
    setMultipleQuestionModal(true);
  };

  const closeSubjectiveQuestionModal = () => {
    setSubjectiveQuestionModal(false);
    setEditingSubjectiveQuestion(null);
    
    // 장르가 선택되지 않은 경우 모든 버튼의 active 상태를 false로 변경
    if (!selectedGenre) {
      setIsRecommendQuestionsVisible(false);
      setIsSubjectiveQuestionsVisible(false);
      setIsGenreBasedQuestionsVisible(false);
    }
  };

  const openSubjectiveQuestionModal = () => {
    const customQuestions = selectedSubjectiveQuestions.filter(q => q.custom);
    const subjectiveLimit = QuestionOverviewData?.customQuestionFreeLimit?.subjectiveLimit || 0;

    if (customQuestions.length >= subjectiveLimit) {
      setLimitModalType('subjective');
      setShowLimitModal(true);
      return;
    }

    setEditingSubjectiveQuestion(null); 
    setSubjectiveQuestionModal(true);
  };


  const { data: gameProposalStepAvailabilityData } = useQuery<GameProposalStepAvailabilityResponse>({
    queryKey: ["gameProposalStepAvailability", gameProposalId], 
    queryFn: async() => {
      const response = await GameProposalStepAvailabilityAPI(Number(gameProposalId));
      return response.data;
    },

    enabled: true
  });

  const queryClient = useQueryClient();

  const { mutate: fetchQuestions } = useMutation({
    mutationFn: (params: { source: string; genre?: string }) => 
      QuestionsBySourceAPI(params.source, params.genre),
    onSuccess: (response, params) => {
      // 장르가 변경되면 커스텀 질문만 유지하고 나머지는 새로운 질문으로 교체
      const customMultipleQuestions = selectedRecommendQuestions.filter((q: Question) => q.custom);
      const customSubjectiveQuestions = selectedSubjectiveQuestions.filter((q: Question) => q.custom);
      
      if (response.data?.multipleChoiceQuestions.length === 0 && response.data?.subjectiveQuestions.length === 0) {
        // 질문이 없는 경우 기본 질문 사용
        if (params.source === 'RECOMMENDED') {
          setSelectedRecommendQuestions([...customMultipleQuestions]);
          setSelectedSubjectiveQuestions([...customSubjectiveQuestions]);
        } else {
          setSelectedRecommendQuestions([...customMultipleQuestions]);
          setSelectedSubjectiveQuestions([...customSubjectiveQuestions]);
        }
      } else {
        // 질문이 있는 경우 응답 데이터 사용
        const { multipleChoiceQuestions, subjectiveQuestions } = response.data;
        setSelectedRecommendQuestions([...customMultipleQuestions, ...multipleChoiceQuestions]);
        setSelectedSubjectiveQuestions([...customSubjectiveQuestions, ...subjectiveQuestions]);
      }
    },
    onError: (error) => {
      console.error("질문 구성 저장 실패:", error);
    }
  });

  const handleRecommendQuestion = () => {
  
    
    setIsGenreBasedQuestionsVisible(false);
    setSelectedGenre(null);
    if (!isRecommendQuestionsVisible) {
      setIsRecommendQuestionsVisible(true);
      setIsSubjectiveQuestionsVisible(true);

      fetchQuestions({ source: 'RECOMMENDED' });
    } else {
      setIsRecommendQuestionsVisible(false);
      setIsSubjectiveQuestionsVisible(false);
      
      setSelectedRecommendQuestions(prev => prev.filter(q => q.custom));
      setSelectedSubjectiveQuestions(prev => prev.filter(q => q.custom));
      
    }
  };

  const handleGenreBasedQuestion = () => {
    console.log(`QuestionOverviewData?.genres: ${QuestionOverviewData?.genres}`);
    if(selectedGenre) {
      setIsRecommendQuestionsVisible(false);
    }
    setIsGenreBasedQuestionsVisible(true);
    setShowGenreModal(true);
  };

  const handleDeleteMultipleChoiceQuestion = (questionId: number) => {
    const updatedQuestions = selectedRecommendQuestions.filter(question => question.questionId !== questionId);
    setSelectedRecommendQuestions(updatedQuestions);
    console.log(`Deleting question with ID: ${questionId}`);
  };

  const handleEditMultipleChoiceQuestion = (question: any) => {
    const questionToEdit = {
      ...question,
      choices: question.choices || [],
      allowMultiple: question.allowMultiple || 1
    };
    setEditingMultipleChoiceQuestion(questionToEdit);
    setMultipleQuestionModal(true);
  };

  const handleDeleteSubjectiveQuestion = (questionId: number) => {
    const updatedQuestions = selectedSubjectiveQuestions.filter(question => question.questionId !== questionId);
    setSelectedSubjectiveQuestions(updatedQuestions);
  };

  const handleEditSubjectiveQuestion = (question: any) => {
    // 속성 매핑 추가: minAnswerLength ↔ answerLength
    const questionToEdit = {
      ...question,
      answerLength: question.minAnswerLength || question.answerLength // 둘 다 확인하고 기본값 설정
    };
    console.log("수정할 주관식 질문:", questionToEdit);  // 디버깅용
    setEditingSubjectiveQuestion(questionToEdit);
    setSubjectiveQuestionModal(true);
  };

  const onDragEndMultipleChoice = (result: any) => {
    if (!result.destination) return;
    
    const items = Array.from(selectedRecommendQuestions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    setSelectedRecommendQuestions(items);
  };

  const onDragEndSubjective = (result: any) => {
    if (!result.destination) return;
    
    const items = Array.from(selectedSubjectiveQuestions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    
    setSelectedSubjectiveQuestions(items);
  };

  const onBeforeDragStart = () => {
    if (document.body) {
      document.body.style.cursor = 'grabbing';
    }
  };

  type MultipleQuestion = {
    questionId: number;
    content: string;
    category: string;
    count: number;
    custom: boolean;
    choices: Array<{id: number; content: string}>;
    rejectionReason: string;
  }
  const handleSave = () => {

    const formattedMultipleQuestions = selectedRecommendQuestions.map(question => {
      if (question.custom) {
        return {
          questionId: null,
          customQuestion: {
            questionId: question.questionId,
            content: question.content,
            // allowedChoices: question.count,
            allowedChoices: question.allowedChoices || question.count,  // 둘 다 확인
            category: "MULTIPLE_CHOICE",
            choices: (question.choices || []).map(choice => ({ content: choice.content })),
            minAnswerLength: 0,
          }
        };
      } else {
        return {
          questionId: question.questionId,
          customQuestion: null
        };
      }
    });
  
    const formattedSubjectiveQuestions = selectedSubjectiveQuestions.map(question => {
      if (question.custom) {
        return {
          questionId: null,
          customQuestion: {
            questionId: question.questionId,
            content: question.content,
            allowedChoices: 0,
            category: "SUBJECTIVE",
            choices: null,
            minAnswerLength: question.answerLength || question.minAnswerLength    // answerLength 사용, 없으면 10
          }
        };
      } else {
        return {
          questionId: question.questionId,
          customQuestion: null
        };
      }
    });

    const data = {
      questionSource: selectedGenre ? 'GENRE_BASED' : (formattedMultipleQuestions.length > 0 ? 'RECOMMENDED' : "NONE"),
      genre: selectedGenre ? selectedGenre : "NONE",
      surveyCategory: 'GAME_TEST',
      multipleQuestions: formattedMultipleQuestions,
      subjectiveQuestions: formattedSubjectiveQuestions

    }
    console.log("data: ", data);
    LabsQuestionComposeAPIMutation.mutate(data, {
      onSuccess: () => {
        const newState = {
          questionSource: selectedGenre ? 'GENRE_BASED' : (formattedMultipleQuestions.length > 0 ? 'RECOMMENDED' : "NONE"),
          genre: selectedGenre ? selectedGenre : "NONE",
          multipleQuestions: selectedRecommendQuestions,
          subjectiveQuestions: selectedSubjectiveQuestions
        };
        setInitialData(JSON.stringify(newState));
        setIsDataChanged(false);
        setShowSuccessModal(true);
        console.log("3단계 저장 성공");

        queryClient.invalidateQueries({ queryKey: ["companyInfoOverview", gameProposalId] });
        queryClient.invalidateQueries({ queryKey: ["gameProposalStepAvailability", gameProposalId] });

        
      },
      onError: (error) => {
        console.log("저장 실패");
      },
    });
  }

  const LabsQuestionComposeAPIMutation = useMutation({
    mutationFn: (data: any) => LabsQuestionComposeAPI(Number(gameProposalId), data),
    onSuccess: (response) => {
      if (response.status === 200) {
        setShowSuccessModal(true);
        console.log("3단계 저장 성공");

        queryClient.invalidateQueries({ queryKey: ["companyInfoOverview", gameProposalId] });
        queryClient.invalidateQueries({ queryKey: ["gameProposalStepAvailability", gameProposalId] });
      }
    },
    onError: (error) => {
      console.log("저장 실패");
    },
  });


  const navigate = useNavigate();

  const { data: gameProposalDetailsData } = useQuery({
    queryKey: ["GameProposalOverview", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalDetailsAPI(Number(gameProposalId));
      return response.data;
    }
  });

  // 상태에 따라 다른 컴포넌트 렌더링
  if (gameProposalDetailsData?.questionCompositionStatus === 'SUBMITTED') {
    return <OnJudgingPhase3 />;
  }

  // 네비게이션 핸들러 수정
  const handleNavigation = (path: string) => {
    if (!initialData || !isDataChanged) {
      navigate(path);
      return;
    }

    setShowMoveModal(true);
    setPendingNavigation(path);
  };

  // 모달 핸들러 추가
  const handleMoveCancel = () => {
    setShowMoveModal(false);
    setPendingNavigation(null);
  };

  const handleMoveConfirm = async () => {
    if (pendingNavigation) {
      const formattedMultipleQuestions = selectedRecommendQuestions.map(question => ({
        questionId: question.custom ? null : question.questionId,
        customQuestion: question.custom ? {
          questionId: null,
          content: question.content,
          allowedChoices: question.allowedChoices,
          category: "MULTIPLE_CHOICE",
          choices: (question.choices || []).map(choice => ({ content: choice.content })),
          minAnswerLength: 0
        } : null
      }));

      const formattedSubjectiveQuestions = selectedSubjectiveQuestions.map(question => ({
        questionId: question.custom ? null : question.questionId,
        customQuestion: question.custom ? {
          questionId: null,
          content: question.content,
          allowedChoices: 0,
          category: "SUBJECTIVE",
          choices: null,
          minAnswerLength: question.minAnswerLength 
        } : null
      }));

      const data = {
        questionSource: selectedGenre ? 'GENRE_BASED' : (formattedMultipleQuestions.length > 0 ? 'RECOMMENDED' : "NONE"),
        genre: selectedGenre ? selectedGenre : "NONE",
        surveyCategory: 'GAME_TEST',
        multipleQuestions: formattedMultipleQuestions,
        subjectiveQuestions: formattedSubjectiveQuestions
      };

      await LabsQuestionComposeAPIMutation.mutateAsync(data, {
        onSuccess: () => {
          // 관련된 모든 쿼리 무효화
          queryClient.invalidateQueries({ queryKey: ["companyInfoOverview", gameProposalId] });
          queryClient.invalidateQueries({ queryKey: ["gameProposalStepAvailability", gameProposalId] });
          
          // 새로운 상태로 초기 데이터 업데이트
          const newState = {
            questionSource: selectedGenre ? 'GENRE_BASED' : (formattedMultipleQuestions.length > 0 ? 'RECOMMENDED' : "NONE"),
            genre: selectedGenre ? selectedGenre : "NONE",
            multipleQuestions: selectedRecommendQuestions,
            subjectiveQuestions: selectedSubjectiveQuestions
          };
          setInitialData(JSON.stringify(newState));
          setIsDataChanged(false);
          
          // 페이지 이동
          navigate(pendingNavigation);
        }
      });
    }
    setShowMoveModal(false);
    setPendingNavigation(null);
  };

  return (
    <>
    <Main>
      {multipleQuestionModal && (
        <MultipleQuestionModal 
          close={closeMultipleQuestionModal} 
          editingQuestion={editingMultipleChoiceQuestion}
          onComplete={(updatedQuestion: MultipleQuestion) => {
            if (editingMultipleChoiceQuestion) {
              setSelectedRecommendQuestions(prev => 
                prev.map(q => q.questionId === updatedQuestion.questionId ? updatedQuestion : q)
              );
            } else {
              setSelectedRecommendQuestions([...selectedRecommendQuestions, updatedQuestion]);
            }
            setEditingMultipleChoiceQuestion(null);
          }}
        />
      )}

      {subjectiveQuestionModal && (
        <SubjectiveQuestionModal close={closeSubjectiveQuestionModal}
        editingQuestion= {editingSubjectiveQuestion}
        onComplete = {(updatedQuestion: {
          questionId: number;
          content: string;
          category: string;
          custom: boolean;
          answerLength: number;
          rejectionReason: string;
        }) => {
          if (editingSubjectiveQuestion) {
            setSelectedSubjectiveQuestions(prev => 
              prev.map(q => q.questionId === updatedQuestion.questionId ? updatedQuestion: q)
            );
        }else {
          setSelectedSubjectiveQuestions([...selectedSubjectiveQuestions, updatedQuestion]);
        }
        setEditingSubjectiveQuestion(null);
        }}
         />
      )}

      <LimitModal 
        isOpen={showLimitModal}
        onClose={() => setShowLimitModal(false)}
        onConfirm={() => {
          setEditingMultipleChoiceQuestion(null); 
          setEditingSubjectiveQuestion(null); 
          setShowLimitModal(false);
          if (limitModalType === 'multiple') {
            setMultipleQuestionModal(true);
          } else {
            setSubjectiveQuestionModal(true);
          }
        }}
        type={limitModalType}
        multipleLimit={QuestionOverviewData?.customQuestionFreeLimit?.multipleChoiceLimit || 0}
        subjectiveLimit={QuestionOverviewData?.customQuestionFreeLimit?.subjectiveLimit || 0}
      />
      
      <GenreModal 
        isOpen={showGenreModal}
        onClose={() => {
          setShowGenreModal(false);
          if (!selectedGenre) {
            setIsGenreBasedQuestionsVisible(false);
          }
        }}
        onConfirm={(selectedGenre: string) => {
          // 장르가 변경되면 기존 질문 목록 초기화
          setSelectedRecommendQuestions(prev => prev.filter(q => q.custom));
          setSelectedSubjectiveQuestions(prev => prev.filter(q => q.custom));
          
          if(selectedGenre) {
            setIsRecommendQuestionsVisible(false);
          }
          setSelectedGenre(selectedGenre);
          
          fetchQuestions({ 
            source: 'GENRE_BASED',
            genre: selectedGenre ? selectedGenre : "NONE"
          });
          setShowGenreModal(false);
        }}
        genres={QuestionOverviewData?.genres || []}
      />
      <TopWrapper>
        <TopContainer>
        <Link to={`/home/test/draft/${gameProposalId}`} style={{ textDecoration: "none" }}>
            <TopTitle>
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{ marginRight: "20px" }}
              />
              3단계 질문 구성
            </TopTitle>
          </Link>
          <BtnContainer>
            <SaveBtn onClick={handleSave}>저장하기</SaveBtn>
          </BtnContainer>
        </TopContainer>
        <NavCotainer>
          <CustomNavLink 
            to={`/home/test-list/${gameProposalId}/add/first`}
            status={gameProposalStepAvailabilityData?.testPlanAvailable}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation(`/home/test-list/${gameProposalId}/add/first`);
            }}
          >
            1. 테스트 플랜
          </CustomNavLink>
          <CustomNavLink 
            to={`/home/test-list/${gameProposalId}/add/second`}
            status={gameProposalStepAvailabilityData?.projectInfoAvailable}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation(`/home/test-list/${gameProposalId}/add/second`);
            }}
          >
            2. 프로젝트 정보
          </CustomNavLink>
          <CustomNavLink 
            to={`/home/test-list/${gameProposalId}/add/third`}
            status={gameProposalStepAvailabilityData?.questionCompositionAvailable}
            isActive={true}
          >
            3. 질문 구성
          </CustomNavLink>
          <TooltipContainer>
            <CustomNavLink 
              to={`/home/test-list/${gameProposalId}/add/forth`}
              status={gameProposalStepAvailabilityData?.estimateAvailable}
              onClick={(e) => {
                e.preventDefault();
                if(gameProposalStepAvailabilityData?.estimateAvailable){
                  handleNavigation(`/home/test-list/${gameProposalId}/add/forth`);
                }
              }}
            >
              4. 견적 확인
            </CustomNavLink>
            
            <Tooltip disabled={!gameProposalStepAvailabilityData?.estimateAvailable}>
              이전 단계의 필수값을 모두 입력해 주세요
            </Tooltip>
          </TooltipContainer>
        </NavCotainer>
      </TopWrapper>
      <ContentWrapper>
        <Title>
          질문 구성
          <Required> *</Required>
        </Title>
        <Comment>
          테스트를 구성할 질문들을 조합해 질문을 구성해주세요.
          <br />
          자동으로 질문이 구성됩니다. 추후 원하는 질문은 직접 추가가 가능합니다.
        </Comment>
        <QuestionWrapper>
          <QuestionContainer>
            <QuestionTitle>추천 질문</QuestionTitle>
            <QuestionContent>플리더스가 추천하는 질문</QuestionContent>
            <QuestionBtn isActive={isRecommendQuestionsVisible} onClick={handleRecommendQuestion}>선택하기</QuestionBtn>
          </QuestionContainer>
          <QuestionContainer>
            <QuestionTitle>장르별 질문</QuestionTitle>
            <QuestionContent>장르별 효과적인 질문</QuestionContent>
            <QuestionBtn isActive={selectedGenre ? true : false} onClick={handleGenreBasedQuestion}>선택하기</QuestionBtn>
          </QuestionContainer>
        </QuestionWrapper>
        <Title>객관식 질문</Title>
        <Comment>현재 총 {selectedRecommendQuestions.length} 문항</Comment>
        <QuestionBox>
          <DragDropContext 
            onDragEnd={onDragEndMultipleChoice}
            onBeforeDragStart={onBeforeDragStart}
          >
            <Droppable droppableId="multipleChoice">
              {(provided) => (
                <DraggableList
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {selectedRecommendQuestions.map((question, index) => (
                    <Draggable
                      key={question.questionId.toString()}
                      draggableId={question.questionId.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <DraggableItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          isDragging={snapshot.isDragging}
                          style={{
                            ...provided.draggableProps.style,
                            visibility: snapshot.isDragging ? 'visible' : 'visible',
                          }}
                        >
                          <QuestionItemContainer 
                            isCustom={question.custom}
                            isDragging={snapshot.isDragging}
                            style={{
                              background: snapshot.isDragging ? '#f0f0f0' : question.custom ? '#2282E9' : '#EBF5FF',
                            }}
                          >
                            <IconContainer 
                              {...provided.dragHandleProps}
                              style={{
                                cursor: snapshot.isDragging ? 'grabbing' : 'grab',
                                touchAction: 'none'
                              }}
                            >
                              <HamburgerIcon />
                            </IconContainer>
                            {question.custom && (
                              <DeleteButtonContainer onClick={() => handleDeleteMultipleChoiceQuestion(question.questionId)}>
                                <MinusIcon />
                              </DeleteButtonContainer>
                            )}
                            <QuestionText hasDeleteButton={question.custom}>
                              {question.content}
                            </QuestionText>
                            
                          {question.custom && (
                            <>
                              {QuestionOverviewData?.questions?.multipleChoiceQuestions
                                ?.find((mcq:any) => mcq.questionId === question.questionId && mcq.custom)
                                ?.rejectionReason && (
                                <div style={{ color: 'white', fontSize: '13px', fontWeight: '400', marginRight: '16px' }}>
                                  {/* 객관식 질문 반려 사유 */}
                                  * 반려사유 : {QuestionOverviewData?.questions?.multipleChoiceQuestions
                                    ?.find((mcq:any) => mcq.questionId === question.questionId && mcq.custom)
                                    ?.rejectionReason}
                                </div>
                              )}
                            </>
                          )}
                            {question.custom && (
                              <ActionButton 
                                onClick={() => handleEditMultipleChoiceQuestion(question)}
                                hasRejection={!!QuestionOverviewData?.questions?.multipleChoiceQuestions
                                  ?.find((mcq:any) => mcq.questionId === question.questionId && mcq.custom)
                                  ?.rejectionReason}
                              >
                                수정
                              </ActionButton>
                            )}
                          </QuestionItemContainer>
                        </DraggableItem>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </DraggableList>
              )}
            </Droppable>
          </DragDropContext>
        </QuestionBox>

        <AddQuestionBtn onClick={openMultipleQuestionModal}>
          + 객관식 질문 추가
        </AddQuestionBtn>
        <Title>주관식 질문</Title>
        <Comment>현재 총 {selectedSubjectiveQuestions.length} 문항</Comment>
        <QuestionBox>
          <DragDropContext 
            onDragEnd={onDragEndSubjective}
            onBeforeDragStart={onBeforeDragStart}
          >
            <Droppable droppableId="subjective">
              {(provided) => (
                <DraggableList
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {selectedSubjectiveQuestions.map((question, index) => (
                    <Draggable
                      key={question.questionId.toString()}
                      draggableId={question.questionId.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <DraggableItem
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          isDragging={snapshot.isDragging}
                          style={{
                            ...provided.draggableProps.style,
                            visibility: snapshot.isDragging ? 'visible' : 'visible',
                          }}
                        >
                          <QuestionItemContainer 
                            isCustom={question.custom}
                            isDragging={snapshot.isDragging}
                            style={{
                              background: snapshot.isDragging ? '#f0f0f0' : question.custom ? '#2282E9' : '#EBF5FF',
                            }}
                          >
                            <IconContainer 
                              {...provided.dragHandleProps}
                              style={{
                                cursor: snapshot.isDragging ? 'grabbing' : 'grab',
                                touchAction: 'none'
                              }}
                            >
                              <HamburgerIcon />
                            </IconContainer>
                            {question.custom && (
                              <DeleteButtonContainer onClick={() => handleDeleteSubjectiveQuestion(question.questionId)}>
                                <MinusIcon />
                              </DeleteButtonContainer>
                            )}
                            <QuestionText hasDeleteButton={question.custom}>
                              {question.content}
                            </QuestionText>
                            {question.custom && (
                              <>
                                {QuestionOverviewData?.questions?.subjectiveQuestions
                                  ?.find((sq:any) => sq.questionId === question.questionId && sq.custom)
                                  ?.rejectionReason && (
                                  <div style={{ color: 'white', fontSize: '13px', fontWeight: '400', marginRight: '16px' }}>
                                    {/* 주관식 질문 반려 사유 */}
                                    * 반려사유 : {QuestionOverviewData?.questions?.subjectiveQuestions
                                      ?.find((sq:any) => sq.questionId === question.questionId && sq.custom)
                                      ?.rejectionReason}
                                  </div>
                                )}
                              </>
                            )}
                            {question.custom && (
                              <ActionButton 
                                onClick={() => handleEditSubjectiveQuestion(question)}
                                hasRejection={!!QuestionOverviewData?.questions?.subjectiveQuestions
                                  ?.find((sq:any) => sq.questionId === question.questionId && sq.custom)
                                  ?.rejectionReason}
                              >
                                수정
                              </ActionButton>
                            )}
                          </QuestionItemContainer>
                        </DraggableItem>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </DraggableList>
              )}
            </Droppable>
          </DragDropContext>
        </QuestionBox>
        <AddQuestionBtn onClick={openSubjectiveQuestionModal} >
          + 주관식 질문 추가
        </AddQuestionBtn>
      </ContentWrapper>
    </Main>
         {showSuccessModal && (
          <SuccessModal onClose={() => setShowSuccessModal(false)} />
        )}
        {showMoveModal && (
          <CheckPageMoveModal
            onClose={handleMoveCancel}
            onConfirm={handleMoveConfirm}
          />
        )}
        </>
  );

}

